// 事件集合
const eventComparison = {
  balanceRefresh: null, // 余额刷新
  promptTone: null, // 提示音
  orderChange: null, // 订单变化
  CounterProcessStaticChange: null, // counter处理静态变化
  CounterBindWallet: null, // 柜台绑定钱包
  paste: null, // 粘贴文本
  counterMemberPayLevelChangeRefresh: null, // 收银台会员等级变化
  counterNoticeRefresh: null, // 通知刷新
};

// 未收到事件通知记录
const notReceiveEventComparison = {
  balanceRefresh: false, // 余额刷新
};

/**
 * 设置事件监听
 */
export const setEventComparison = (eventName, fn) => {
  eventComparison[eventName] = fn;
};

/**
 * 执行事件
 */
export const runEvent = (eventName, params) => {
  if (eventComparison[eventName]) {
    eventComparison[eventName](params);
  }

  // 设置是否收到事件通知记录
  setIsNotReceiveEvent(eventName, eventComparison[eventName] !== null);
};

/**
 * 是否收到事件通知记录
 */
const setIsNotReceiveEvent = (eventName, isNotReceive) => {
  // 获取所有需要记录的事件
  const keys = Object.keys(notReceiveEventComparison);

  // 如果需要记录的事件包含当前事件，则设置是否收到事件通知记录
  if (keys.includes(eventName)) {
    // 设置是否收到事件通知记录
    notReceiveEventComparison[eventName] = isNotReceive;
  }
};

/**
 * 获取是否有未收到的通知
 */
export const getIsNotReceiveEvent = eventName => {
  // 获取是否有未收到该事件的记录
  const isNotReceive = notReceiveEventComparison[eventName];

  // 如果有未收到该事件的记录，则清除记录
  if (isNotReceive) {
    notReceiveEventComparison[eventName] = false;
  }

  // 返回是否有未收到该事件的记录
  return isNotReceive;
};
